


































































































import { Component, Vue } from "vue-property-decorator";
import {
  NEGATIVE_RULE_FLAGS,
  HCS_LEVELS
} from "@/constants/questionnaire_answer";
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate";
import HealthCheckSummaryIssuedBodyMap from "./partials/HealthCheckSummaryIssuedBodyMap.vue";
import HealthCheckSummaryBodyMapSeverityLevel from "./partials/HealthCheckSummaryBodyMapSeverityLevel.vue";
import { mapState } from "vuex";

@Component({
  components: {
    HealthCheckSummaryIssuedBodyMap,
    HealthCheckSummaryBodyMapSeverityLevel
  },
  computed: {
    ...mapState("QuestionnaireAnswer", {
      healthCheckSummary: "healthCheckSummary"
    })
  }
})
export default class HealthCheckSummary extends Vue {
  healthCheckSummary!: QuestionnaireAnswerState["healthCheckSummary"];

  negativeRuleFlags = NEGATIVE_RULE_FLAGS;
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;

  isPaying = false;
  retryCount = 0;
  isMounted = false;
  timer: NodeJS.Timeout | null = null;

  beforeMount() {
    this.init();
  }

  get riskOutcome() {
    switch (this.healthCheckSummary?.overall_level.value) {
      case HCS_LEVELS.HCS_LEVEL_VERY_GOOD:
        return {
          color: this.negativeRuleFlags[11].color,
          text: this.healthCheckSummary?.overall_level.text
        };
      case HCS_LEVELS.HCS_LEVEL_GOOD:
        return {
          color: this.negativeRuleFlags[13].color,
          text: this.healthCheckSummary?.overall_level.text
        };
      case HCS_LEVELS.HCS_LEVEL_COULD_BE_BETTER:
        return {
          color: this.negativeRuleFlags[15].color,
          text: this.healthCheckSummary?.overall_level.text
        };
      default:
        return {
          color: this.negativeRuleFlags[15].color,
          text: this.healthCheckSummary?.overall_level.text
        };
    }
  }

  async init() {
    this.retryCount = 0;
    this.isPaying = true;
    while (this.retryCount < 1) {
      await this.$store.dispatch(
        "QuestionnaireAnswer/fetchHCS",
        this.$route.params.questionnaireAnswerOid
      );
      await this.wait(3000);
      this.retryCount += 1;
    }
    this.timer = null;
    this.isPaying = false;
    this.isMounted = true;
  }

  wait(ms) {
    return new Promise(resolve => {
      this.timer = setTimeout(resolve, ms);
    });
  }
}
